import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EstoniaPersonalCodeValidator } from './estonia-personal-code.validator';
import { FinlandPersonalCodeValidator } from './finland-personal-code.validator';
import { CountryCode } from '../../enums/country-code.enum';

export abstract class PersonalCodeValidatorAbstract {
    public abstract getPersonalCodeValidator(): ValidatorFn;
}

@Injectable({
    providedIn: 'root'
})
export class PersonalCodeValidator {
    personalValidator: PersonalCodeValidatorAbstract;

    public getValidator(reverse = false): ValidatorFn {
        const validator = this.personalValidator.getPersonalCodeValidator();
        return reverse ? this.reverseValidator(validator) : validator;
    }

    public initialize(countryCode: CountryCode) {
        switch (countryCode) {
            case CountryCode.FINLAND:
                this.personalValidator = new FinlandPersonalCodeValidator();
                break;
            case CountryCode.ESTONIA:
                this.personalValidator = new EstoniaPersonalCodeValidator();
                break;
            default:
                this.personalValidator = new EstoniaPersonalCodeValidator();
                break;
        }
    }

    private reverseValidator(validator: ValidatorFn): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const result = validator(control);
            return result === null ? { personalCodeNotAllowed: true } : null;
        };
    }
}
